// 1. Enum of strings for selection type
export enum UIUMSelectionType {
  RejectWhenPossible = 'Reject when possible, Minimum when required',
  IndividualState = 'Individual State Selection',
  StateMinimum = 'Minimum Limit, No Rejection',
  PolicyLiabilityLimits= 'Selects UM/UIM coverage at a limit equal to my policy liability limit'
}

// 2. Enum of strings for limit type
export enum LimitType {
  CombinedSingleLimit = 'Combined Single Limit',
  Split = 'Split',
  VaryBetweenStates = 'Vary between States',
}

// 2. Enum of strings for limit type
export enum PDFGenerationStatus {
  RequestNotSentYet = 'Request Not Sent Yet',
  RequestSent = 'Request Sent',
  ResponseReceived = 'Response Received',
  Error = 'Error',
}

// 3. Enum of strings for stacked options
export enum StackType {
  NonStacked = 'Non Stacked',
  Stacked = 'Stacked',
}

// 4. Enum of strings for coverages
export enum CoverageType {
  BodilyInjuryWithMandatoryPropertyDamage = 'Bodily injury with mandatory Property Damage / Reject where possible',
  BodilyInjuryWithOptionalPropertyDamage = 'Bodily injury with mandatory / Optional Property Damage',
}
export enum GaragingSelectionType {
  GaragingStateSelection = 'GaragingStateSelection',
  AllStateSelection = 'AllStateSelection',
}

export const UserRole = {
  INSURED: 'insured',
  BROKER: 'broker',
};
export enum FormType {
  UM_UIM = 'um_uim',
  PIP = 'pip',
}

export enum RequestProgressStep {
  DIGITAL_SIGNATURE_CONSENT = 'DIGITAL_SIGNATURE_CONSENT',
  SELECTION_OF_COVERAGES = 'SELECTION_OF_COVERAGES',
  REVIEW_STATE_SELECTIONS = 'REVIEW_STATE_SELECTIONS',
  OUTSTANDING_STATE_SELECTIONS = 'OUTSTANDING_STATE_SELECTIONS',
  ELECTRONIC_SIGNATURE = 'ELECTRONIC_SIGNATURE',
  NON_DIGITAL_ELECTION_DOWNLOAD = 'NON_DIGITAL_ELECTION_DOWNLOAD',
  NON_DIGITAL_ELECTION_SHIP_FORMS = 'NON_DIGITAL_ELECTION_SHIP_FORMS',
  THANK_YOU = 'THANK_YOU',
}

export const PIP_MASTER_STATES_LIST = [
  'Colorado',
  'Arkansas',
  'District of Columbia',
  'Delaware',
  'Florida',
  'Hawaii',
  'Kansas',
  'Kentucky',
  'Maine',
  'Massachusetts',
  'Maryland',
  'Michigan',
  'Minnesota',
  'Nevada',
  'New Jersey',
  'New York',
  'North Dakota',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'Texas',
  'Utah',
  'Virginia',
  'Wisconsin',
];

export const UM_MASTER_STATES_LIST = [
  'Alaska',
  'Alabama',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

// PDF custom state order sorted by two-letter code (AK, AL, ...)
export const PDF_CUSTOM_STATE_ORDER = [
  'alaska',
  'alabama',
  'arkansas',
  'arizona',
  'california',
  'colorado',
  'connecticut',
  'districtofcolumbia',
  'districtofcolumbia_119199',
  'districtofcolumbia_63583',
  'delaware',
  'florida',
  'georgia',
  'hawaii',
  'idaho',
  'illinois',
  'indiana',
  'iowa',
  'iowa_62590',
  'iowa_119200',
  'kansas',
  'kentucky',
  'louisiana',
  'maine',
  'maryland',
  'massachusetts',
  'michigan',
  'minnesota',
  'mississippi',
  'missouri',
  'montana',
  'nebraska',
  'nevada',
  'newhampshire',
  'newjersey',
  'newmexico',
  'newyork',
  'northcarolina',
  'northdakota',
  'ohio',
  'oklahoma',
  'oregon',
  'pennsylvania',
  'pennsylvania_62585',
  'pennsylvania_62598',
  'rhodeisland',
  'southcarolina',
  'southdakota',
  'tennessee',
  'texas',
  'utah',
  'vermont',
  'virginia',
  'virginia_62604',
  'virginia_148621',
  'washington',
  'westvirginia',
  'westvirginia_78927',
  'westvirginia_78928',
  'westvirginia_78929',
  'westvirginia_78930',
  'westvirginia_78931',
  'wisconsin',
  'wyoming',
];
